import { memo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import type { InferType } from 'yup';
import { tikTokSchema } from '../validation/tiktok.schema';
import TikTokForm from './TikTokForm';

export type TikTokFormValues = InferType<typeof tikTokSchema>;

const TikTokFormProvider = memo(() => {
  const formMethods = useForm<TikTokFormValues>({
    resolver: yupResolver(tikTokSchema),
    defaultValues: {
      currentStep: 0,
      app: '',
      adType: 'SINGLE_VIDEO',
      accountId: '',
      selectedAdGroups: [],
      selectedCampaigns: [],
      selectedCampaignsOnly: false,
      selectedCreatives: [],
      packsWithCreatives: [
        {
          tag: '',
          creatives: [],
          filterCreativeByName: [],
        },
      ],
      activePacksWithCreatives: 0,
      filterCreativeByName: '',
      filterCampaignsByName: [],
      filterAdSetsByName: [],
      $adSetsData: [],
    },
  });

  return (
    <FormProvider {...formMethods}>
      <TikTokForm />
    </FormProvider>
  );
});

TikTokFormProvider.displayName = 'TikTokFormWrapper';

export default TikTokFormProvider;
